import { Outlet } from 'react-router'
import { NavLink } from 'react-router-dom'

import { ROUTER_NAMES } from 'router/routerNames'

import styles from './ManualReportsLayout.module.scss'

function activeClassName({ isActive }: { isActive: boolean }) {
  return `${styles.nav_item} ${isActive ? styles.active : ''}`
}

export const ManualReportsLayout = () => {
  return (
    <>
      <div className="container">
        <div className={styles.nav_list}>
          <NavLink
            end
            className={activeClassName}
            to={ROUTER_NAMES.MANUAL_REPORTS}
          >
            Карты
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.REVIVAL_REPORTS}>
            Реанимация
          </NavLink>
          <NavLink className={activeClassName} to={ROUTER_NAMES.ACQUIRED_CLIENTS_REPORTS}>
            Привлеченные
          </NavLink>
        </div>
      </div>

      <Outlet />
    </>
  )
}
